/*****************************************************************************************************************************************************
 * Revision History
 * 2024-08-21 TBH - Changes to allow OLLI waitlist courses. Modified handleEnrollstatus() to set enrollStatus to Open, Full, or Closed (added Full).
 * 2024-08-22 TBH - Changed bindCartList() requestType from 1 (Added) to 0 (All) so waitlisted courses checked. 
 *    NOTE: Also had to update unx_sp_web_OLLICartDisplay to support this ability.
 * 2024-08-25 TBH - Added break; after cart item match found in bindCart() (optimization).
 * 2024-08-26 TBH - Added cartCourseKey[] to use instead of cartCourseSerialId[] to identify OLLI course using serialId + academicTerm
 *    since two courses in different terms can have same serial ID.
 *****************************************************************************************************************************************************/

import { OlliCartUrl } from "../directives/utilities/urls";
export default function olliCoursesList() {
    return {
        formData: {
            currentPageName: ''
        },
        form: {},
        passedEventType: '',
        passedAcademicTerm: '',
        passedAcademicYear: '',
        passedCourseLength: '',
        selectedCategoryFilter: null,
        categoryList: [],
        seasonList: [],
        showErrorMesage: false,
        selectedDeliveryOptions: [],
        selectedApprovedOptions: [],
        selectedCourseLength: [],
        selectedCreditCEUOptions: [],
        selectedQuarter: [],
        coursesList: [],
        tempCoursesList: [],
        totalCount: 0,
        pageCount: 0,
        currentPage: 1,
        hasMore: false,
        isSearchCall: false,
        showLoader: false,
        detailPageUrl: '',
        enrollStatus: '',
        selectedQuarter: '',
        enrollmentCartList: [],
        cartCourseSerialId: [],
        cartCourseKey:[],                     /* serialId + academicTerm */
        passedCartCount: 0,
        checkOutMessage: '',
        olliCartUrl: OlliCartUrl,
        paginate(pageNumber) {
            this.currentPage = pageNumber;
            this.bindCoursesList();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.bindCoursesList();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.bindCoursesList();
           
        },
        searchCourses() {

        },

        addCartList(item, matchedSerialId) {
          if( item.enrollStatus.toLowerCase() == "closed" || matchedSerialId == "matched") {
            return( false );
            }

          var jsonData = JSON.stringify({
            "SessionId": "123",
            "AcademicYear": item.academicYear,
            "AcademicTerm": item.academicTerm,
            "AcademicSession": "OLLI",
            "SerialId": item.serialId
            });

          fetch("/api/OlliCheckout/check-if-added-to-cart", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              },
            body: jsonData,
            })
            .then(( response ) => { return( response.json()); })
            .then(( response ) => {
              this.showLoader = false;

              if( response != undefined && response.isSuccess && !response.alreadyAdded ) {
                jsonData = JSON.stringify({
                  "UserSessionId": "",
                  "AcademicYear": item.academicYear,
                  "AcademicTerm": item.academicTerm,
                  "AcademicSession": "OLLI",
                  "SerialId": item.serialId,
                  "CheckoutType": "OLLI"
                  });

                this.showLoader = true;
                this.passedCartCount = 0;
                fetch("/api/Checkout/add-course-to-cart", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    },
                  body: jsonData,
                  })
                  .then((response) => { return( response.json()); })
                  .then((response) => {
                    this.showLoader = false;
                    if( response != undefined && response.isSuccess ) {
                      this.passedCartCount = response.cartCount;
                      jsonData = JSON.stringify({
                        "AcademicYear": item.academicYear,
                        "AcademicTerm": item.academicTerm,
                        });

                      fetch('/api/OlliCheckout/LoadMembership', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          },
                        body: jsonData
                        })
                        .then( response => {
                          if( response.ok ) {
                            return( response.json())
                            }
                          })
                        .then( response => {
                          if( response != undefined && response.isSuccess ) {                                             
                            this.bindCartList();
                            document.getElementById('cartPathAnchor').style.display = "block";
                            document.getElementById('cartPathAnchorMobile').style.display = "block";
                            document.getElementById('cartPathAnchor').href = OlliCartUrl;
                            document.getElementById('cartCountSpan').textContent = this.passedCartCount;
                            document.getElementById('cartPathAnchorMobile').href = OlliCartUrl;
                            document.getElementById('cartCountSpanMobile').textContent = this.passedCartCount;
                                                
                            return true;
                            } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later."
// console.log( 'addCartList() - Error.' );
                            }
                          });
                        } else if (!response.isSuccess && response.checkoutTypeError) {
                          this.checkOutMessage = response.message
                          document.getElementById('btnCartCheckOutError').click();
                          } else if (!response.isSuccess && response.message == "Not Logged In") {
                          window.location.href = OlliCartUrl
                          } else {
                          this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log( 'addCartList() - Error.' );
                          }
                        });
                    } else if (response.isSuccess && response.alreadyAdded) {
                        alert("You already purchased this course.")
                    }
                });
        },
        
        bindCartList() {
          var jsonData = JSON.stringify({
            SessionId: "",
            RequestType: 0      /* Check all cart request types so waitlisted courses checked. Was 1 (Added only). */
            });

          this.enrollmentCartList = [];
          fetch("/api/OlliCheckout/GetOLLICheckOutCartCourse", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              },
            body: jsonData,
            })
          .then(( response ) => {
            return response.json();
            })
          .then((response) => {
            if( response != undefined && response.isSuccess ) {

              if (response.cartItems.length > 0) {
                this.enrollmentCartList = response.cartItems;
                for (let i = 0; i < response.cartItems.length; i++) {
                  for (let j = 0; j < this.cartCourseSerialId.length; j++) {

/* TODO: Test and if OK use instead of cartCourseSerialId.
                    var cartItemKey = response.cartItems[i].serialId + response.cartItems[i].academicTerm;
                    if( this.cartCourseKey[j] == cartItemKey ) {
                      this.cartCourseKey[j] == "matched";
                      break;
                    }
*/
                    if( this.cartCourseSerialId[j] == response.cartItems[i].serialId ) {
                      this.cartCourseSerialId[j] = "matched";
                      break;
                      }
                    }
                  }
                this.showErrorMesage = "";
                }
                    
              } 
            else {
              this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log( 'bindCartList() - Error.' );
              }
            });
          },

        formatDate(dateValue) {
          const options = { month: 'short', day: 'numeric' };
          const formattedDate = new Date(dateValue).toLocaleDateString(undefined, options);
          return formattedDate;
          },

        getEnrollmentStatus(item) {
            switch (item.enrollmentStatus) {
                case 0:
                    return "Unknown";
                    break;
                case 1:
                    return "Enroll by " + this.formatDate(item.startDate);
                    break;
                case 2:
                    return "Join Waitlist";
                    break;
                case 3:
                    //Registration begins
                    return "Registration begins " + this.formatDate(item.startDate);
                    break;
                case 4:
                    return "Ending " + this.formatDate(item.endDate);
                    break;
                case 5:
                    return "Closed for Registration";
                    break;
                case 6:
                    return "GetInfo";
                    break;
            }
        },
        getClassNameByEnrollmentStatus(enrollmentStatus) {
            switch (enrollmentStatus) {
                case 0:
                    return "Unknown";
                    break;
                case 1:
                    return "block text-center xl:inline-block px-2 py-1 text-sm bg-lightBlue";
                    break;
                case 2:
                    return "block text-center xl:inline-block px-2 py-1 text-sm bg-lightYellow";
                    break;
                case 3:
                    //Registration begins
                    return "block text-center xl:inline-block px-2 py-1 text-sm bg-lightGreen";
                    break;
                case 4:
                    //return "Ending";
                    return "block text-center xl:inline-block px-2 py-1 text-sm bg-lightBlue";
                    break;
                case 5:
                    return "block text-center xl:inline-block px-2 py-1 text-sm bg-lightRed";
                    break;
                case 6:
                    return "GetInfo";
                    break;
            }
        },
        bindSeasonList() {
    
            fetch('/api/OlliCheckout/GetOLLISession', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.seasonList, response.seasons);
                        if (this.seasonList.length <= 0) {
                            this.showErrorMesage = "No Seasons Found";
                        }
                        else {
                            this.passedAcademicYear = this.seasonList[0].academicYear;
                            this.passedAcademicTerm = this.seasonList[0].academicTerm;
                            this.bindCoursesList();
                            this.selectedQuarter = this.passedAcademicTerm + this.passedAcademicYear;
                        }

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log( 'bindSeasonList() - Error.' );
                    }

                });
            
        },
        handleAnchorClick(clickedCategoryCode) {
            
            this.passedEventType = clickedCategoryCode;
            //Alpline.store('clickedCategoryCode', clickedCategoryCode);
            this.coursesList = [];
            this.currentPage = 1;
            this.cartCourseSerialId = [];
            this.cartCourseKey = [];
            this.bindCoursesList();

        },
        handleQuarterClick(clickedQuarter) {

            this.passedAcademicTerm = clickedQuarter.academicTerm;
            this.passedAcademicYear = clickedQuarter.academicYear;
            this.selectedQuarter = this.passedAcademicTerm + this.passedAcademicYear;
            this.coursesList = [];
            this.currentPage = 1;
            this.cartCourseSerialId = [];
            this.cartCourseKey = [];
            this.bindCoursesList();
        },
        //handleDeliveryOptionsClick(clickedValue) {
        //    this.selectedDeliveryOptions = clickedValue;
        //    this.isSearchCall = true;
        //    this.bindCoursesList();

        //},
        handleCoursesLengthClick(clickedVal) {
            this.selectedCourseLength = clickedVal;
            this.isSearchCall = true;
            this.bindCoursesList();
        },
        handleEnrollstatus( status ) {
        /* This used to set status text below "Status". Parameter status s/b this.enrollmentStatus. */
          if( status == 'min' || status == 'target' || status == 'open' ) 
            return( "Open" );
          if( status == 'full' ) 
            return( "Full" );
          if( status == 'closed' )
            return( "Closed" );

          return( status );
          },
        bindCoursesList() {
           
            this.showLoader = true;
                var pageSize = 10;
                this.hasMore = false;
                fetch('/api/ProgramAPI/GetOLLICourseSearch', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        AcademicYear: this.passedAcademicYear,
                        AcademicTerm: this.passedAcademicTerm,
                        Type: this.passedEventType ? this.passedEventType : "",
                        //CourseLength: this.selectedCourseLength > 0 ? parseInt(this.selectedCourseLength) : 0,
                        //DeliveryMode: this.selectedDeliveryOptions != '' ? this.selectedDeliveryOptions : '',
                        PageSize: pageSize,
                        PageNumber: this.currentPage
                    })
                }).then(response => {
                    return response.json();
                }).then(response => {
                    this.showLoader = false;
                    this.passedCartCount = response.olliCourseCount;
                    if (response != undefined && response.isSuccess) {
                        
                        Array.prototype.push.apply(this.coursesList, response.courses);
                        if (response.courses.length > 0) {
                            for (let i = 0; i < response.courses.length; i++) {
                                this.cartCourseSerialId.push(response.courses[i].serialId);
                                this.cartCourseKey.push( response.courses[i].serialId + response.courses[i].academicTerm );
                            }
                            this.bindCartList();
                        } 
                        this.hasMore = response.hasMore;
                        this.showErrorMesage = response.message;
                       
                    } else {
                        this.showErrorMesage = response.message;
                    }

                });
            
        },
        init() {
            this.bindSeasonList();
                    
            this.enrollStatus = this.enrollStatus ? this.enrollStatus : "";
            this.detailPageUrl = document.getElementById('hdnPageUrl').value;
           
        }
    }
}